"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var ContentRowResponsive_1 = __importDefault(require("../ContentRowResponsive/ContentRowResponsive"));

exports.ContentRow = styled_components_1.default(ContentRowResponsive_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-items: flex-start;\n"], ["\n    align-items: flex-start;\n"])));
var templateObject_1;